__webpack_require__.p = "/ui-refresh-navigtion-module/onboarding/";